import settings from './settings';

/**
 * Evalutes data attributes set on the element. Supported data attributes are as follows:
 * ```
 * data-autoplay
 * data-muted
 * data-ad-tag
 * data-volume
 * data-controls
 * data-dock
 * data-disable-ads
 * data-aspect-ratio
 * ```
 *
 * @param {HTMLElement} element
 */
export function evaluateDOMSettings(element) {
  const prefix = settings.dataAttributePrefix || 'data';

  const autoplay = element.getAttribute(`${prefix}-autoplay`);
  const muted = element.getAttribute(`${prefix}-muted`);
  const adTag = element.getAttribute(`${prefix}-ad-tag`);
  const volume = element.getAttribute(`${prefix}-volume`);
  const controls = element.getAttribute(`${prefix}-controls`);
  const dock = element.getAttribute(`${prefix}-dock`);
  const aspectRatio = element.getAttribute(`${prefix}-aspect-ratio`);
  const disableAds = element.getAttribute(`${prefix}-disable-ads`);

  return {
    autoplay: autoplay ? autoplay === 'true' || autoplay === '1' : null,
    muted: muted ? muted === 'true' || muted === '1' : null,
    controls: controls ? controls === 'true' || controls === '1' : null,
    dock: dock ? dock === 'true' || dock === '1' : null,

    // special handling, as volume is 1.0 -> 0.0
    volume: volume ? parseFloat(volume) : null,

    // since these are strings, they can be just passed through
    adTag,
    aspectRatio,

    // special case, as we are flipping the conditional here
    ads: disableAds ? disableAds === 'false' || disableAds === '0' : null,
  };
}

/**
 * Evalutes the settings of the embed and the DOM to return what the player should use
 * for trying to set up video.js
 *
 * @param {HTMLElement} element
 * @param {Embed} embed
 */
export function evaluateSettings(element, embed) {
  const {
    autoplay,
    adTag,
    ads,
    muted,
    aspectRatio,

    volume,
    dock,
    controls,
  } = evaluateDOMSettings(element);

  return {
    // combined with the embed
    autoplay: autoplay !== null ? autoplay : embed.autoplay,
    adTag: adTag !== null ? adTag : embed.adTag,
    ads: ads !== null ? ads : embed.adsEnabled,
    muted: muted !== null ? muted : embed.muted,
    aspectRatio: aspectRatio !== null ? aspectRatio : embed.aspectRatio,

    // default for now
    volume: volume !== null ? volume : 1,
    dock: dock !== null ? dock : true,
    controls: controls !== null ? controls : true,
  };
}
